var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAddress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5C2.23333 0.5 0 3.3475 0 6.875C0 11.125 5 17.5 5 17.5C5 17.5 10 11.125 10 6.875C10 3.3475 7.76667 0.5 5 0.5ZM5 2.625C6.85 2.625 8.33333 4.5375 8.33333 6.875C8.33333 9.23375 6.85 11.125 5 11.125C3.16667 11.125 1.66667 9.23375 1.66667 6.875C1.66667 4.5375 3.16667 2.625 5 2.625Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAddress);
export default __webpack_public_path__ + "static/media/icon-address.905859e61219b7797921798485c391a1.svg";
export { ForwardRef as ReactComponent };